// extracted by mini-css-extract-plugin
module.exports = {"loading-wrapper":"page-loading_loading-wrapper__mJ_8v"};